// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__Z4D6-"};